import { TimeRangeDto } from './time-range-dto';

export class SearchRequestDto {
   clientId: string = '';
   queryString: string = '';
   timeRanges: Array<TimeRangeDto> = new Array();
   size: number = 25;
   from: number = 1;
   indexTypes: Array<string> = new Array();
   timestampMapping: { [type: string]: string } = {};
   sortType: SortTypeEnum;
   sortField: string;
   indexTypeBoost: boolean = false;
   highlight: boolean = true;
   timeout: number;
   highlightOpenTag: string;
   highlightCloseTag: string;
   timeSort: boolean;
   dropActiveSearches: boolean;

   constructor(queryString?: string, timeRange?: Array<TimeRangeDto>, indexTypes?: Array<string>, timestampMapping?: { [type: string]: string }, size?: number, from?: number) {
      if (queryString) {
         this.queryString = queryString;
      }
      if (timeRange) {
         this.timeRanges = timeRange;
      }
      if (indexTypes) {
         this.indexTypes = indexTypes;
      }
      if (timestampMapping) {
         this.timestampMapping = timestampMapping;
      }
      if (from) {
         this.from = from;
      }
      if (size) {
         this.size = size;
      }
   }
}

export enum SortTypeEnum {
   ASC = <any>"ASC",
   DESC = <any>"DESC"
}